import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Label } from '@primer/react';
import { StarIcon, CopilotIcon } from '@primer/octicons-react';
import { PropTableValues } from '../../src/components';
import { PricingOptions } from '@primer/react-brand';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PricingOptions>
  <PricingOptions.Item>
    <PricingOptions.Label>Recommended</PricingOptions.Label>
    <PricingOptions.Heading>Copilot</PricingOptions.Heading>
    <PricingOptions.Description>
      Copilot in the coding environment.
    </PricingOptions.Description>
    <PricingOptions.Price
      currencySymbol="$"
      trailingText="per month / $100 per year"
    >
      10
    </PricingOptions.Price>
    <PricingOptions.FeatureList>
      <PricingOptions.FeatureListItem>
        Everything in Copilot Business plus:
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Chat in IDE and Mobile
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        CLI assistance
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Code completions
      </PricingOptions.FeatureListItem>
    </PricingOptions.FeatureList>
    <PricingOptions.PrimaryAction href="/buy">
      Buy now
    </PricingOptions.PrimaryAction>
    <PricingOptions.SecondaryAction href="/contact">
      Contact sales
    </PricingOptions.SecondaryAction>
  </PricingOptions.Item>

  <PricingOptions.Item>
    <PricingOptions.Label>Recommended</PricingOptions.Label>
    <PricingOptions.Heading>Copilot Business</PricingOptions.Heading>
    <PricingOptions.Description>
      Copilot personalized to your organization throughout the software
      development lifecycle. Requires GitHub Enterprise Cloud.
    </PricingOptions.Description>
    <PricingOptions.Price currencySymbol="$" trailingText="per user / month">
      39
    </PricingOptions.Price>
    <PricingOptions.FeatureList>
      <PricingOptions.FeatureListItem>
        Everything in Copilot Business plus:
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Chat in IDE and Mobile
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        CLI assistance
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Code completions
      </PricingOptions.FeatureListItem>
    </PricingOptions.FeatureList>
    <PricingOptions.PrimaryAction href="/buy">
      Join waitlist
    </PricingOptions.PrimaryAction>
  </PricingOptions.Item>
</PricingOptions>
`}</code></pre>
    <h3>{`Cards variant`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PricingOptions variant="cards">
  <PricingOptions.Item>
    <PricingOptions.Label>Recommended</PricingOptions.Label>
    <PricingOptions.Heading>Copilot</PricingOptions.Heading>
    <PricingOptions.Description>
      Copilot in the coding environment.
    </PricingOptions.Description>
    <PricingOptions.Price
      currencySymbol="$"
      trailingText="per month / $100 per year"
    >
      10
    </PricingOptions.Price>
    <PricingOptions.FeatureList>
      <PricingOptions.FeatureListItem>
        Everything in Copilot Business plus:
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Chat in IDE and Mobile
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        CLI assistance
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Code completions
      </PricingOptions.FeatureListItem>
    </PricingOptions.FeatureList>
    <PricingOptions.PrimaryAction href="/buy">
      Buy now
    </PricingOptions.PrimaryAction>
    <PricingOptions.SecondaryAction href="/contact">
      Contact sales
    </PricingOptions.SecondaryAction>
  </PricingOptions.Item>

  <PricingOptions.Item>
    <PricingOptions.Label>Recommended</PricingOptions.Label>
    <PricingOptions.Heading>Copilot Business</PricingOptions.Heading>
    <PricingOptions.Description>
      Copilot personalized to your organization throughout the software
      development lifecycle. Requires GitHub Enterprise Cloud.
    </PricingOptions.Description>
    <PricingOptions.Price currencySymbol="$" trailingText="per user / month">
      39
    </PricingOptions.Price>
    <PricingOptions.FeatureList>
      <PricingOptions.FeatureListItem>
        Everything in Copilot Business plus:
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Chat in IDE and Mobile
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        CLI assistance
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Code completions
      </PricingOptions.FeatureListItem>
    </PricingOptions.FeatureList>
    <PricingOptions.PrimaryAction href="/buy">
      Join waitlist
    </PricingOptions.PrimaryAction>
  </PricingOptions.Item>
</PricingOptions>
`}</code></pre>
    <h3>{`One option`}</h3>
    <p>{`This is the one-option layout for the pricing options component`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PricingOptions>
  <PricingOptions.Item>
    <PricingOptions.Heading>Copilot Individual</PricingOptions.Heading>
    <PricingOptions.Description>
      Code completions, Chat, and more for indie developers and freelancers.
    </PricingOptions.Description>
    <PricingOptions.Price
      currencySymbol="$"
      trailingText="per month / $100 per year"
    >
      10
    </PricingOptions.Price>
    <PricingOptions.PrimaryAction href="/buy">
      Buy now
    </PricingOptions.PrimaryAction>
    <PricingOptions.SecondaryAction href="/contact">
      Contact sales
    </PricingOptions.SecondaryAction>
  </PricingOptions.Item>
</PricingOptions>
`}</code></pre>
    <h3>{`Two options`}</h3>
    <p>{`This is the two-item layout for the pricing options component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PricingOptions>
  <PricingOptions.Item>
    <PricingOptions.Label>Recommended</PricingOptions.Label>
    <PricingOptions.Heading>Copilot</PricingOptions.Heading>
    <PricingOptions.Description>
      Copilot in the coding environment.
    </PricingOptions.Description>
    <PricingOptions.Price
      currencySymbol="$"
      trailingText="per month / $100 per year"
    >
      10
    </PricingOptions.Price>
    <PricingOptions.FeatureList>
      <PricingOptions.FeatureListItem>
        Everything in Copilot Business plus:
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Chat in IDE and Mobile
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        CLI assistance
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Code completions
      </PricingOptions.FeatureListItem>
    </PricingOptions.FeatureList>
    <PricingOptions.PrimaryAction href="/buy">
      Buy now
    </PricingOptions.PrimaryAction>
    <PricingOptions.SecondaryAction href="/contact">
      Contact sales
    </PricingOptions.SecondaryAction>
  </PricingOptions.Item>

  <PricingOptions.Item>
    <PricingOptions.Label>Recommended</PricingOptions.Label>
    <PricingOptions.Heading>Copilot Business</PricingOptions.Heading>
    <PricingOptions.Description>
      Copilot personalized to your organization throughout the software
      development lifecycle. Requires GitHub Enterprise Cloud.
    </PricingOptions.Description>
    <PricingOptions.Price currencySymbol="$" trailingText="per user / month">
      39
    </PricingOptions.Price>
    <PricingOptions.FeatureList>
      <PricingOptions.FeatureListItem>
        Everything in Copilot Business plus:
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Chat in IDE and Mobile
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        CLI assistance
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Code completions
      </PricingOptions.FeatureListItem>
    </PricingOptions.FeatureList>
    <PricingOptions.PrimaryAction href="/buy">
      Join waitlist
    </PricingOptions.PrimaryAction>
  </PricingOptions.Item>
</PricingOptions>
`}</code></pre>
    <h3>{`Three options`}</h3>
    <p>{`This is the three-option layout for the pricing options component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Note>
  \`PricingOptions\` is designed to fill the width of the page's main container,
  thus it cannot be accurately represented within the narrower container of this
  documentation. 
  
  Please refer to our [Storybook examples](https://primer.style/brand/storybook/?path=/story/components-pricingoptions-features--three-options) to see the component in a full-width context as originally intended.
</Note>
`}</code></pre>
    <h3>{`Feature list sets`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`PricingOptions.FeatureListHeading`}</inlineCode>{` to group feature items together.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PricingOptions>
  <PricingOptions.Item>
    <PricingOptions.Heading>Copilot Individual</PricingOptions.Heading>
    <PricingOptions.Description>
      Code completions, Chat, and more for indie developers and freelancers.
    </PricingOptions.Description>
    <PricingOptions.Price
      currencySymbol="$"
      trailingText="per month / $100 per year"
    >
      10
    </PricingOptions.Price>
    <PricingOptions.FeatureList>
      <PricingOptions.FeatureListHeading>
        Base features
      </PricingOptions.FeatureListHeading>
      <PricingOptions.FeatureListItem>
        Code completions
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Chat in IDE and Mobile
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        CLI assistance
      </PricingOptions.FeatureListItem>

      <PricingOptions.FeatureListHeading>
        Security
      </PricingOptions.FeatureListHeading>
      <PricingOptions.FeatureListItem>
        Security vulnerability filter
      </PricingOptions.FeatureListItem>
    </PricingOptions.FeatureList>

    <PricingOptions.Footnote>
      Free for verified students, teachers, and maintainers of popular open
      source projects.
    </PricingOptions.Footnote>

    <PricingOptions.PrimaryAction href="/buy">
      Start a free trial
    </PricingOptions.PrimaryAction>
  </PricingOptions.Item>

  <PricingOptions.Item>
    <PricingOptions.Label>Recommended</PricingOptions.Label>
    <PricingOptions.Heading>Copilot Business</PricingOptions.Heading>
    <PricingOptions.Description>
      Copilot personalized to your organization.
    </PricingOptions.Description>
    <PricingOptions.Price currencySymbol="$" trailingText="per user / month">
      19
    </PricingOptions.Price>
    <PricingOptions.PrimaryAction href="/buy">
      Buy now
    </PricingOptions.PrimaryAction>
    <PricingOptions.SecondaryAction href="/contact">
      Contact sales
    </PricingOptions.SecondaryAction>
    <PricingOptions.FeatureList>
      <PricingOptions.FeatureListHeading>
        Base features
      </PricingOptions.FeatureListHeading>
      <PricingOptions.FeatureListItem>
        Everything in Copilot Individual
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Code referencing
      </PricingOptions.FeatureListItem>

      <PricingOptions.FeatureListHeading>
        Security
      </PricingOptions.FeatureListHeading>
      <PricingOptions.FeatureListItem>
        Security vulnerability filter
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Public code filter
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        IP indemnity
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Enterprise-grade security, safety, and privacy
      </PricingOptions.FeatureListItem>
    </PricingOptions.FeatureList>
  </PricingOptions.Item>

  <PricingOptions.Item>
    <PricingOptions.Label>Available Feb 2024</PricingOptions.Label>
    <PricingOptions.Heading>Copilot Enterprise</PricingOptions.Heading>
    <PricingOptions.Description>
      Copilot personalized to your organization throughout the software
      development lifecycle. Requires GitHub Enterprise Cloud.
    </PricingOptions.Description>
    <PricingOptions.Price currencySymbol="$" trailingText="per user / month">
      39
    </PricingOptions.Price>
    <PricingOptions.FeatureList>
      <PricingOptions.FeatureListHeading>
        Base features
      </PricingOptions.FeatureListHeading>
      <PricingOptions.FeatureListItem>
        Everything in Copilot Business
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Documentation search and summaries
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Pull request summaries
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Code review skills
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListHeading>
        Security
      </PricingOptions.FeatureListHeading>
      <PricingOptions.FeatureListItem>
        Security vulnerability filter
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Public code filter
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        IP indemnity
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Enterprise-grade security, safety, and privacy
      </PricingOptions.FeatureListItem>
    </PricingOptions.FeatureList>
    <PricingOptions.PrimaryAction href="/waitlist">
      Join waitlist
    </PricingOptions.PrimaryAction>
  </PricingOptions.Item>
</PricingOptions>
`}</code></pre>
    <h3>{`Included and excluded features`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`PricingOptions.FeatureListItem`}</inlineCode>{` with `}<inlineCode parentName="p">{`variant="included"`}</inlineCode>{` and `}<inlineCode parentName="p">{`variant="excluded"`}</inlineCode>{` to list included and excluded features.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PricingOptions>
  <PricingOptions.Item>
    <PricingOptions.Heading>Copilot Individual</PricingOptions.Heading>
    <PricingOptions.Description>
      Code completions, Chat, and more for indie developers and freelancers.
    </PricingOptions.Description>
    <PricingOptions.Price
      currencySymbol="$"
      trailingText="per month / $100 per year"
    >
      10
    </PricingOptions.Price>
    <PricingOptions.FeatureList>
      <PricingOptions.FeatureListHeading>
        Chat
      </PricingOptions.FeatureListHeading>
      <PricingOptions.FeatureListItem>
        Unlimited messages, interactions, and history
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Context-aware coding support and explanations
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem variant="excluded">
        Debugging and security remediation assistance
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem variant="excluded">
        Repository-based semantic search
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem variant="excluded">
        Access your knowledge base
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListHeading>
        Code completion
      </PricingOptions.FeatureListHeading>
      <PricingOptions.FeatureListItem>
        Code suggestions as you type
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Comments to code
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem variant="excluded">
        Fine-tuned models (coming soon)
      </PricingOptions.FeatureListItem>
    </PricingOptions.FeatureList>

    <PricingOptions.Footnote>
      Free for verified students, teachers, and maintainers of popular open
      source projects.
    </PricingOptions.Footnote>

    <PricingOptions.PrimaryAction href="/buy">
      Start a free trial
    </PricingOptions.PrimaryAction>
  </PricingOptions.Item>

  <PricingOptions.Item>
    <PricingOptions.Label>Recommended</PricingOptions.Label>
    <PricingOptions.Heading>Copilot Business</PricingOptions.Heading>
    <PricingOptions.Description>
      Copilot personalized to your organization.
    </PricingOptions.Description>
    <PricingOptions.Price currencySymbol="$" trailingText="per user / month">
      19
    </PricingOptions.Price>
    <PricingOptions.PrimaryAction href="/buy">
      Buy now
    </PricingOptions.PrimaryAction>
    <PricingOptions.SecondaryAction href="/contact">
      Contact sales
    </PricingOptions.SecondaryAction>
    <PricingOptions.FeatureList>
      <PricingOptions.FeatureListHeading>
        Chat
      </PricingOptions.FeatureListHeading>
      <PricingOptions.FeatureListItem>
        Unlimited messages, interactions, and history
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Context-aware coding support and explanations
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Debugging and security remediation assistance
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Repository-based semantic search
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem variant="excluded">
        Access your knowledge base
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListHeading>
        Code completion
      </PricingOptions.FeatureListHeading>
      <PricingOptions.FeatureListItem>
        Code suggestions as you type
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Comments to code
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem variant="excluded">
        Fine-tuned models (coming soon)
      </PricingOptions.FeatureListItem>
    </PricingOptions.FeatureList>
  </PricingOptions.Item>

  <PricingOptions.Item>
    <PricingOptions.Label>Available Feb 2024</PricingOptions.Label>
    <PricingOptions.Heading>Copilot Enterprise</PricingOptions.Heading>
    <PricingOptions.Description>
      Copilot personalized to your organization throughout the software
      development lifecycle. Requires GitHub Enterprise Cloud.
    </PricingOptions.Description>
    <PricingOptions.Price currencySymbol="$" trailingText="per user / month">
      39
    </PricingOptions.Price>
    <PricingOptions.FeatureList>
      <PricingOptions.FeatureListHeading>
        Chat
      </PricingOptions.FeatureListHeading>
      <PricingOptions.FeatureListItem>
        Unlimited messages, interactions, and history
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Context-aware coding support and explanations
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Debugging and security remediation assistance
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Repository-based semantic search
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Access your knowledge base
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListHeading>
        Code completion
      </PricingOptions.FeatureListHeading>
      <PricingOptions.FeatureListItem>
        Code suggestions as you type
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Comments to code
      </PricingOptions.FeatureListItem>
      <PricingOptions.FeatureListItem>
        Fine-tuned models (coming soon)
      </PricingOptions.FeatureListItem>
    </PricingOptions.FeatureList>
    <PricingOptions.PrimaryAction href="/waitlist">
      Join waitlist
    </PricingOptions.PrimaryAction>
  </PricingOptions.Item>
</PricingOptions>
`}</code></pre>
    <h2>{`Component props`}</h2>
    <h3>{`PricingOptions `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`as`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[`section`, `div`]} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`section`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Applies the underlying HTML element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PricingOptions.Item`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Applies the underlying HTML element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`variant`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[`default`, `cards`]} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The variant styling`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`PricingOptions.Item `}<Label mdxType="Label">{`Required`}</Label></h3>
    <p>{`One item per pricing plan to be displayed. Maximum of 3 items.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={['PricingOptions.Heading', 'PricingOptions.Label', 'PricingOptions.Price', 'PricingOptions.FeatureList', 'PricingOptions.Footnote']} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The contents of the item`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`PricingOptions.Heading `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`as`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`h3, h4, h5, h6`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`h3`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Applies the underlying HTML heading level element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The heading of the item`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`PricingOptions.Label`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The label of the item`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`PricingOptions.Description`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The description of the item`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`PricingOptions.Price`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The price of the item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`currencyCode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`USD`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The currency code`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`currencySymbol`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`$`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The currency symbol`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`originalPrice`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The initial price before any discounts are applied`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`trailingText`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The trailing text`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`PricingOptions.FeatureList`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={['PricingOptions.Heading', 'PricingOptions.Item']} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The list of features`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`PricingOptions.FeatureListHeading`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`as`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`h4, h5, h6`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`h4`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Applies the underlying HTML heading level element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The heading of the feature list set`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`PricingOptions.FeatureListItem`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The item of the feature list set`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`variant`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[`included`, `excluded`]} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`included`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The variant of the feature list set`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`PricingOptions.Footnote`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The footnote of the item`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      